import { GameVars } from "../GameVars";
import { GameManager } from "../GameManager";
import { GameConstants } from "../GameConstants";

export class BootScene extends Phaser.Scene {

    public static currentInstance: BootScene;
    private static restartOnCorrectOrientation: boolean;
    private static checkWhetherToRestart: boolean;
    private static orientationCounter: number;

    public static onFullscreen(): void {

        if (!GameVars.currentScene.game.device.os.iOS) {

            GameVars.currentScene.time.delayedCall(100, () => {

                BootScene.currentInstance.game.scale.displaySize = BootScene.currentInstance.game.scale.parentSize;
                BootScene.setScaleFactor();
                BootScene.currentInstance.game.scale.refresh();
            }, [], this);
        }
    }

    public static staticUpdate(): void { // this method should be placed in updates of other scenes.

        if (BootScene.orientationCounter > -1) {
            BootScene.orientationCounter--;

            if (BootScene.orientationCounter === 0) {

                BootScene.orientationCounter--;

                BootScene.refreshOrientation();
            }
        }
    }

    private static setScaleFactor() {

        const aspectRatio = window.innerHeight / window.innerWidth;

        if (aspectRatio <= 1.35) {
            GameVars.correctionScale = .75;
        } else if (aspectRatio <= 1.55) {
            GameVars.correctionScale = .8;
        } else if (aspectRatio <= 1.65) {
            GameVars.correctionScale = .9;
        } else {
            GameVars.correctionScale = 1;
        }

        GameVars.scaleY = (GameConstants.GAME_HEIGHT / GameConstants.GAME_WIDTH) / aspectRatio;
    }

    private static checkOrientation() {

        // resume placed here because orientation check depends on game not being paused
        // if entering wrong orientation, this resume() is overwritten by a pause()
        // after the counter runs out
        if (GameVars.currentScene) { GameVars.currentScene.scene.resume(); }

        BootScene.orientationCounter = 20;
    }

    private static enterIncorrectOrientation(): void {

        GameVars.currentScene.scene.pause();

        document.getElementById("orientation").style.display = "block";
    }

    private static leaveIncorrectOrientation(): void {

        document.getElementById("orientation").style.display = "none";

        if (BootScene.restartOnCorrectOrientation) {

            BootScene.restartOnCorrectOrientation = false;
            BootScene.setScaleFactor();
            BootScene.currentInstance.scene.restart();
        }
    }

    private static refreshOrientation(): void {

        let landscape = window.innerWidth > window.innerHeight;

        if (!landscape) {

            BootScene.leaveIncorrectOrientation();

            if (BootScene.checkWhetherToRestart) {
                BootScene.restartOnCorrectOrientation = false;
            }

        } else {

            BootScene.enterIncorrectOrientation();

            if (BootScene.checkWhetherToRestart) {
                BootScene.restartOnCorrectOrientation = true;
            }
        }
        
        BootScene.checkWhetherToRestart = false;

        BootScene.currentInstance.game.scale.displaySize = BootScene.currentInstance.game.scale.parentSize;
        BootScene.setScaleFactor();
        BootScene.currentInstance.game.scale.refresh();
    }

    constructor() {

        super("BootScene");
    }

    public preload(): void {

        this.load.bitmapFont("sarpanch", "assets/fonts/sarpanch.png", "assets/fonts/sarpanch.xml");

        this.load.json("languages", "assets/texts/languages.json");
    }

    public create(): void {

        BootScene.currentInstance = this;
        GameManager.setCurrentScene(this);

        this.add.text(0, 0, "abcdefg", { fontFamily: "Sarpanch-Black", fontSize: 28, color: "#A6F834" });

        BootScene.orientationCounter = -1;

        if (this.sys.game.device.os.desktop) {

            GameVars.scaleY = 1;
            GameVars.correctionScale = 1;

        } else {

            if (GameVars.currentScene.game.device.os.iOS) {

                window.addEventListener("orientationchange", function () {
                    BootScene.checkOrientation();
                });

                BootScene.checkOrientation();

            } else {

                this.game.scale.on("orientationchange", BootScene.checkOrientation, BootScene.currentInstance);
                BootScene.checkOrientation();
            }

            BootScene.checkWhetherToRestart = true;

            BootScene.currentInstance.game.scale.displaySize = BootScene.currentInstance.game.scale.parentSize;
            BootScene.setScaleFactor();
            BootScene.currentInstance.game.scale.refresh();
        }
        
        GameManager.init();
    }
}
